const path = 'redux/User';
export const USER_SIGNED_OUT = `${path}/USER_SIGNED_OUT`;
export const USER_SIGNED_IN = `${path}/USER_SIGNED_IN`;
export const UPDATE_USER_TOKEN = `${path}/UPDATE_USER_TOKEN`;
export const TOGGLE_MENU = `${path}/TOGGLE_MENU`;
export const USERS_LOADED = `${path}/USERS_LOADED`;
export const TOGGLE_USER_ENABLED = `${path}/TOGGLE_USER_ENABLED`;
export const ACCOUNTS_LOADED = `${path}/ACCOUNTS_LOADED`;
